import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import cn from 'classnames';
import lottie from 'lottie-web';
import styles from './LottiePlayer.module.scss';
export function LottiePlayer(param) {
    let { animationData, path, loop = false, autoplay = false, onComplete, className, testId } = param;
    const containerRef = useRef(null);
    useEffect(()=>{
        if (!containerRef.current) return;
        const animationInstance = lottie.loadAnimation(_object_spread({
            container: containerRef.current,
            renderer: 'svg',
            loop,
            autoplay
        }, animationData ? {
            animationData
        } : {}, path ? {
            path
        } : {}));
        if (onComplete) {
            animationInstance.addEventListener('complete', onComplete);
        }
        return ()=>{
            animationInstance.destroy();
        };
    }, [
        animationData,
        path,
        loop,
        autoplay,
        onComplete
    ]);
    return /*#__PURE__*/ _jsx("div", {
        ref: containerRef,
        className: cn(styles.root, className),
        "data-testid": testId
    });
}
